export default __webpack_public_path__ + "static/media/header_cover_mobile.9fa343ef.png";